import makeActionCreator from 'make-action-creator'

import { NAMESPACE } from './constants'

export const loginUser = makeActionCreator(NAMESPACE + '/loginUser')
export const signupUser = makeActionCreator(NAMESPACE + '/signupUser')
export const googleAuth = makeActionCreator(NAMESPACE + '/googleAuth')